/**
 * The HTML class property name
 * @type {String}
 */
const HTML_CLASS_ATTRIBUTE = 'class';

/**
 * The HTML style property name
 * @type {String}
 */
const HTML_STYLE_ATTRIBUTE = 'style';

/**
 * Maps a react attributes into dom format.
 */
const ATTRIBUTES_DOM_ALIAS_MAP = {
    'accentHeight': 'accent-height',
    'alignmentBaseline': 'alignment-baseline',
    'arabicForm': 'arabic-form',
    'baselineShift': 'baseline-shift',
    'capHeight': 'cap-height',
    'clipPath': 'clip-path',
    'clipRule': 'clip-rule',
    'colorInterpolation': 'color-interpolation',
    'colorInterpolationFilters': 'color-interpolation-filters',
    'colorProfile': 'color-profile',
    'colorRendering': 'color-rendering',
    'fillOpacity': 'fill-opacity',
    'fillRule': 'fill-rule',
    'floodColor': 'flood-color',
    'floodOpacity': 'flood-opacity',
    'fontFamily': 'font-family',
    'fontSize': 'font-size',
    'fontSizeAdjust': 'font-size-adjust',
    'fontStretch': 'font-stretch',
    'fontStyle': 'font-style',
    'fontVariant': 'font-variant',
    'fontWeight': 'font-weight',
    'glyphName': 'glyph-name',
    'glyphOrientationHorizontal': 'glyph-orientation-horizontal',
    'glyphOrientationVertical': 'glyph-orientation-vertical',
    'horizAdvX': 'horiz-adv-x',
    'horizOriginX': 'horiz-origin-x',
    'markerEnd': 'marker-end',
    'markerMid': 'marker-mid',
    'markerStart': 'marker-start',
    'overlinePosition': 'overline-position',
    'overlineThickness': 'overline-thickness',
    'panose1': 'panose-1',
    'paintOrder': 'paint-order',
    'stopColor': 'stop-color',
    'stopOpacity': 'stop-opacity',
    'strikethroughPosition': 'strikethrough-position',
    'strikethroughThickness': 'strikethrough-thickness',
    'strokeDasharray': 'stroke-dasharray',
    'strokeDashoffset': 'stroke-dashoffset',
    'strokeLinecap': 'stroke-linecap',
    'strokeLinejoin': 'stroke-linejoin',
    'strokeMiterlimit': 'stroke-miterlimit',
    'strokeOpacity': 'stroke-opacity',
    'strokeWidth': 'stroke-width',
    'textAnchor': 'text-anchor',
    'textDecoration': 'text-decoration',
    'textRendering': 'text-rendering',
    'underlinePosition': 'underline-position',
    'underlineThickness': 'underline-thickness',
    'unicodeBidi': 'unicode-bidi',
    'unicodeRange': 'unicode-range',
    'unitsPerEm': 'units-per-em',
    'wordSpacing': 'word-spacing',
    'writingMode': 'writing-mode',
    'enableBackground': 'enable-background',
    'xlinkHref': 'xlink:href',
    'xmlSpace': 'xml:space',
    'xmlnsXlink': 'xmlns:xlink'
};

module.exports = {
    HTML_STYLE_ATTRIBUTE,
    HTML_CLASS_ATTRIBUTE,
    ATTRIBUTES_DOM_ALIAS_MAP
};
